import { deepEqual } from '@utils/deep-equal';
import type { Lot } from 'types';

/** The next lot, holding the previous lot's headers array when the two are equal, so header-keyed grid settings keep their identity. */
export const keepEqualHeaders = (previous: Lot, next: Lot): Lot => (
  next.custom_column_headers !== previous.custom_column_headers
    && deepEqual(previous.custom_column_headers, next.custom_column_headers)
    ? { ...next, custom_column_headers: previous.custom_column_headers }
    : next
);
